import { Breadcrumb, Col, Row, Space } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLazyGetContactQuery } from './redux/ContactUsApi';
import { ReactComponent as POI } from '../../assets/images/POI.svg';
import { ReactComponent as Phone } from '../../assets/images/phone.svg';
import { ReactComponent as Mail } from '../../assets/images/mail.svg';
import { Feature } from 'ol';
import * as olProj from 'ol/proj';
import { Geometry, Point } from 'ol/geom';

import MapWrapper from '../../map/Index';
import BranchItem from './components/BranchItem';
import { ContactResponse } from './types';

const ContactUs = () => {
    const divRef = useRef<HTMLDivElement>(null);
    const [features, setFeatures] = useState<Feature<Geometry>[]>([]);
    const [headquarter, setHeadquarter] = useState<ContactResponse>();
    const [branches, setBranches] = useState<ContactResponse[]>([]);

    const [contactTrigger] = useLazyGetContactQuery();

    useEffect(() => {
        if (divRef.current) {
            divRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }, [])

    useEffect(() => {
        contactTrigger({}).unwrap().then(res => {
            setHeadquarter(res.content.find(item => item.type === 0))
            setBranches(res.content.filter(item => item.type === 1));

            let iconFeatures: Feature<Geometry>[] = [];
            res.content.forEach(item => {
                let newFeature = new Feature({
                    geometry: new Point([item.lon, item.lat]),
                    name: item.title,
                    address: item.address,
                    url: `https://www.google.com/maps/search/?api=1&query=${item.lat}%2C${item.lon}`,
                    location: [item.lon, item.lat],
                })

                newFeature.getGeometry()?.transform('EPSG:4326', 'EPSG:3857')
                iconFeatures.push(newFeature)
            })

            setFeatures(iconFeatures)
        });
    }, [contactTrigger])

    return (
        <div
            ref={divRef}
            style={{
                // padding: '40px calc((100vw - 1440px) / 2) 40px',
                background: "#ececec",
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                width: '100%',
                paddingTop: 40,
                paddingBottom: 40,
            }}
        >
            <Space style={{ display: 'flex', alignItems: 'center' }} className="responsive-padding-1440">
                <Breadcrumb separator="  " className="custom-breadcrumb">
                    <Breadcrumb.Item>
                        <Link to="/">
                            Trang chủ
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        Liên hệ
                    </Breadcrumb.Item>
                </Breadcrumb>

                <div className="responsive-title">Thông tin liên hệ</div>
            </Space>

            <div style={{ marginTop: 40 }} className="responsive-padding-1440">
                <div style={{ border: '1px dashed black', borderRadius: 15, padding: '20px 60px', background: 'white' }}>
                    <div className="font-size-28 font-bold text-overflow-custom">{headquarter?.title || ""}</div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                        <POI style={{ height: 20 }} />
                        <span style={{ paddingLeft: 16, fontSize: 16 }} className="text-overflow-custom">
                            {headquarter?.address || ""}
                        </span>
                    </div>
                    <div style={{ marginTop: 10, display: 'flex', alignItems: 'center' }}>
                        <Phone style={{ height: 20, color: 'black' }} />
                        <span style={{ paddingLeft: 16, fontSize: 16 }} className="text-overflow-custom">
                            {headquarter?.mobile || ""}
                        </span>
                    </div>
                    <div style={{ marginTop: 10, display: 'flex', alignItems: 'center' }}>
                        <Mail style={{ height: 20, color: 'black' }} />
                        <a href={`mailto:${headquarter?.email || ""}`} style={{ paddingLeft: 16, fontSize: 16 }} className="text-overflow-custom">
                            {headquarter?.email || ""}
                        </a>
                    </div>
                </div>

                <Row style={{ marginTop: 10, height: 250, overflow: 'auto' }} gutter={[20, 20]}>
                    {
                        branches.map(item => (
                            <Col sm={24} md={12} key={item.id}>
                                <BranchItem branchItem={item} />
                            </Col>
                        ))
                    }
                </Row>

                <div style={{ marginTop: 50, borderRadius: 15, width: '100%', height: 680 }}>
                    {headquarter && headquarter.lat && headquarter.lon ?
                        <MapWrapper
                            features={features}
                            center={olProj.transform([headquarter.lon, headquarter.lat], 'EPSG:4326', 'EPSG:3857')}
                            zoom={15}
                            height={680} />
                        : <></>}
                </div>
            </div>

        </div>
    )
}

export default ContactUs;